module.exports = "https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-page/register/POP@3x.33adf2fb.png";